exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner[data-v-693604e9]{padding:0;height:24px;border:3px solid hsla(0,7%,5%,.89)}.inner i[data-v-693604e9]{transform:rotate(90deg);position:relative;top:-2px}.inner span[data-v-693604e9]{background-color:#1f1f1f;position:relative;width:22px;display:inline-block;height:100%;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-693604e9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/WidgetScrollbar.vue
// module id = 86
// module chunks = 0